export default __webpack_public_path__ + "static/media/aboutUs-en.1977abdc.webp";